import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Props from './ContinueCheckoutBannerComponent';
import SelectLanguage from './SelectLanguage';
import { withNavigation } from '@b/helpers/withNavigation';
import { TIME_REMAINING_THRESHOLD } from '@v/checkout/components/MoreTimeModal';
import { createPortal } from 'react-dom';
import clsx from 'clsx';

const tabletBreakpoint = '768';

class ContinueCheckoutBanner extends Component<Props> {
    cartPlaceholder = null;

    state = {
      parentScreenWidth: window?.parent?.innerWidth,
    };

    setSessionStorageValue = (key, value) => {
      window.parent.sessionStorage.setItem(key, value);
    }

    getSessionStorageValue = (key) => {
      return window.parent.sessionStorage.getItem(key);
    }

    onWindowResize = () => {
      this.setState({
        parentScreenWidth: window?.parent?.innerWidth,
      });
    };

    componentDidMount() {
      if (this.props.isDynamicListing) {
        window?.parent.addEventListener('resize', this.onWindowResize);
      }

      if (window.frameElement && window.parent) {
        this.cartPlaceholder = window.parent.document.querySelector('.cart-pill__placeholder');
      }
    }

    componentWillUnmount() {
      window?.parent.removeEventListener('resize', this.onWindowResize);
    }

    componentDidUpdate() {
      if (!window.frameElement || !window.parent) {
        return;
      }

      if (!this.props.hasReservation ||
        !this.props.allowExtendTime ||
        this.props.timeRemainingExtended ||
        this.props.isKioskMode ||
        this.props.timeRemainingSeconds > TIME_REMAINING_THRESHOLD ||
        this.props.timeRemainingSeconds <= 0) {

        this.setSessionStorageValue('moreTimeModalOnOpenFired', 'false');
        return;
      }

      this.onOpen();
    }

    onOpen = () => {
      if (this.getSessionStorageValue('moreTimeModalOnOpenFired') === 'true' ||
        this.getSessionStorageValue('moreTimeModalClosed') === 'true') {
        return;
      }

      this.props.navigate("/more-time")
      this.props.setCheckoutOverlay(true);
      this.setSessionStorageValue('moreTimeModalOnOpenFired', 'true');
    }

    shouldShow = () => {
      if (this.props.isDynamicListing) {
        return true;
      }
      return this.props.showCartPill && (this.props.itemCount > 0 || this.props.forceShow);
    }

    renderContent = () => {
      let pillClass = 'checkout__cart-pill';
      if (this.props.isDynamicListing) {
        pillClass += ' checkout__cart-pill-dynamic-listing';
      }

      const mainClassName = this.props.isDynamicListing && this.state?.parentScreenWidth >= tabletBreakpoint
        ? 'checkout__bar checkout__bar--with-margin'
        : 'checkout__bar';
      
      return (
        <div className={clsx(mainClassName, this.cartPlaceholder && this.props.pinToBottom && 'checkout__bar--bottom')}>
          <SelectLanguage className='select-language--listing' />
          {this.shouldShow() && (
            <button className={pillClass} onClick={this.props.showCart} disabled={!this.props.hasReservation}>
              {this.props.timeRemaining !== '00:00' &&
                <span className="checkout__cart-pill__timer">
                  <i className="icon-clock" />
                  <span className="checkout__cart-pill__timer-time" aria-live='polite'>
                    {this.props.timeRemaining}
                  </span>
                </span>
              }
              <span className="checkout__cart-pill__items">
                <i className="icon-shopping_cart" />
                {+this.props.itemCount > 0 && (
                  <span className="checkout__cart-pill__items-count">
                    {this.props.itemCount}
                  </span>
                )}
              </span>
            </button>
          )}
        </div>
      )
    }

    render() {
      this.cartPlaceholder = window.parent.document.querySelector('.org-listing__header');

      if (this.cartPlaceholder) {
        return createPortal(
          this.renderContent(),
          this.cartPlaceholder
        );
      }

      return this.renderContent();
    }
}

ContinueCheckoutBanner.propTypes = {
    showCart: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired
}

export default withNavigation(ContinueCheckoutBanner);
